import { createContext, useContext, useEffect, useState } from 'react';

// What a query reports when there is no window to ask. Only the build-time
// render (scripts/prerender.mjs) provides one: it renders the page once per
// viewport range and answers each query for that range. Without a provider
// every query is false, as before.
export const MediaQueryFallbackContext = createContext(() => false);

// Live boolean for a CSS media query. Only for decisions that change WHAT
// renders (a carousel instead of a grid, an icon instead of a label); anything
// that only changes how it looks belongs in a stylesheet media query instead.
const useMediaQuery = query => {
  const fallback = useContext(MediaQueryFallbackContext);
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined'
      ? window.matchMedia(query).matches
      : fallback(query)
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = e => setMatches(e.matches);
    // re-sync in case `query` changed since the initial render
    setMatches(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
};

export default useMediaQuery;
